export default __webpack_public_path__ + "static/media/user.7c586796.svg";